import { Bus } from './../../../models/bus';
import { AuthService } from './../../../services/auth.service';
import { NgxRolesService } from 'ngx-permissions';
import { Client } from './../../../models/client';
import { Passenger } from './../../../models/passenger';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { RequestOptions } from '@angular/http';
import { Select2OptionData } from 'ng2-select2';
import { PNotifyService } from '../../../services/pnotify.service';
declare const google: any;
import * as moment from 'moment';
import * as XLSX from 'xlsx';
import { info } from 'console';

@Component({
  selector: 'app-passenger-addlist',
  templateUrl: './passenger-addlist.component.html',
  styleUrls: ['./passenger-addlist.component.css']
})
export class PassengerAddlistComponent implements OnInit {

  isAssistant: boolean;
  routeBase: string;
  passenger: Passenger;
  clients: any[];
  clientId: any;
  schools: any[];
  buses: any[];
  school: any;
  ListPassager: any = null;
  public typeAddData: Array<Select2OptionData>;
  public clientsData: any[];
  public schoolsData: any[];
  public busesData: any[];
  public subscriptionsData: any[];
  typeAddSelected: any = '';
  codesToGenerate : any = 30;
  selectedBus : any;
  selectedFile : any;
  pnotify = undefined;
  option: any;
  map: any;
  markers: any[];
  markerBounds: any;
  isResponsible = false;
  // ----- Start Ion Range Slider -----------
  ion_min = moment('0000', 'hmm').format('X');
  ion_max = moment('2359', 'hmm').format('X');
  ion_from = moment('0000', 'hmm').format('X');
  ion_to = moment('2359', 'hmm').format('X');
  hourFormat = function (num) {
    const m = moment(num, 'X');
    return m.format('HH:mm');
  };
  formatX = function (time: string) {
    return moment(time, 'h:mm').format('X');
  };
  // ----- Start Ion Range Slider -----------
  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private roleService: NgxRolesService,
    pnotifyService: PNotifyService
  ) {
    this.isAssistant = false;
    this.routeBase = 'passenger';
    this.passenger = new Passenger();
    this.initClientSelect();
    this.initSchoolSelect();
    this.subscriptionsData = [
      {
        id: 'Aller/Retour',
        text: 'Aller/Retour',
        selected: this.passenger.subscription == 'Aller/Retour' ? true : false
      },
      {
        id: 'Aller',
        text: 'Aller',
        selected: this.passenger.subscription == 'Aller' ? true : false
      },
      {
        id: 'Retour',
        text: 'Retour',
        selected: this.passenger.subscription == 'Retour' ? true : false
      },
    ];
    this.typeAddData = [
      { id: '', text: 'Choisir une option' },
      { id: 'code', text: 'Generation des codes'},
      { id: 'passenger', text: 'Ajout des passagers'}
      ];
    this.pnotify = pnotifyService.getPNotify();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
  }

  ngOnInit() {
    this.route.data
      .subscribe((data: { isAssistant: boolean }) => {
        this.routeBase = data.isAssistant ? 'assistant' : 'passenger';
        this.isAssistant = data.isAssistant ? true : false;
        this.passenger.isAssistant = this.isAssistant;
        this.passenger.count = 0;
      });
    //this.initMap();
    //this.map.fitBounds(this.markerBounds);
  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clientId = client.id;
      this.clientsData = [{ id: client.id, text: client.name }];
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clientId = client.id;
      this.clientsData = [{ id: client.id, text: client.name }];
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        const array1 = [{ id: '', text: 'Choisir un client' }];
        const array2 = this.clients.map(function (client, index) {
          return { id: client.id, text: client.name };
        });
        this.clientsData = array1.concat(array2);
      });
    }
  }
  clientChanged(e: any) {
    this.clientId = e.value;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    //console.log("this.clientId",this.clientId);
    const params = new HttpParams({
      fromObject: {
        clientId: this.clientId + ''
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      this.schoolsData = this.schools.map((school, index) => {
        if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
          return {
            id: school.id,
            text: school.name,
            selected: (this.authService.getUser().School.id === school.id) ? true : false
          };
        } else {
          return { id: school.id, text: school.name };
        }
      });
      //console.log("schoolsData",this.schoolsData);
    });
  }
  schoolChanged(e: any) {
    this.passenger.schoolId = e.value;
    this.initBusSelect();
  }

  typeAddChanged(e: any){
    this.passenger.busId = null;
    this.selectedBus = null;
    this.typeAddSelected = e.value;
  }

  initBusSelect() {
    let params = new HttpParams({
      fromObject: {
        clientId: this.clientId + '',
        schoolId: this.passenger.schoolId + ''
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      const array1 = [{ id: '', text: 'Choisir un bus' }];
      const array2 = this.buses.map(function (bus, index) {
        return { id: bus.id, text: bus.name };
      });
      this.busesData = array1.concat(array2);
    });
  }
  
  busCodeChanged(e: any) {
    // this.deleteMarkers();
    this.selectedBus = e.value;
    this.passenger.busId = e.value;
  }

  busPassengerChanged(e: any) {
    // this.deleteMarkers();
    this.passenger.busId = e.value;
  }

  changeFileListener(e: any){
    this.uploadExcel(e.target).then((ListPassagerJson)=> {
      if(ListPassagerJson){
        this.ListPassager = ListPassagerJson;
        this.selectedFile = 1;
      }else{
        this.ListPassager = null;
        this.selectedFile = null;
      }

    });
  }

  uploadExcel (inputValue: any):Promise <any>{
    let jsonData = null;
    let ListPassagerJson = null;
    var myFile: File = inputValue.files[0];
    var myReader: FileReader =  new FileReader();
    myReader.readAsBinaryString(myFile);
    return new Promise((resolve,reject)=>{
      myReader.onload = function(){
        var fileData = myReader.result;
        var workbook = XLSX.read(fileData,{type: 'binary'});
        jsonData = workbook.SheetNames.reduce((initial, name) => {
          const sheet = workbook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet);
          return initial;
        }, {});
        ListPassagerJson = JSON.parse(JSON.stringify(jsonData));

        resolve(ListPassagerJson);
    };
  });
}

formatDate(date) {
  let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }
  return [year, month, day].join('-');
}

onSubmit(): void {

    const passengerMap = {}; // Map to store passengers with the same name and phone number

    this.passenger.am1Start = moment('0000', 'hmm').format('X');
    this.passenger.am1End = moment('2359', 'hmm').format('X');
    this.passenger.pm1Start = moment('0000', 'hmm').format('X');
    this.passenger.pm1End = moment('2359', 'hmm').format('X');
    this.passenger.am2Start = moment('0000', 'hmm').format('X');
    this.passenger.am2End = moment('2359', 'hmm').format('X');
    this.passenger.pm2Start = moment('0000', 'hmm').format('X');
    this.passenger.pm2End = moment('2359', 'hmm').format('X');

    const q = new Date();
    const m = q.getMonth(); // Date object has month from 0-11
    const d = q.getDate();
    let y   = q.getFullYear();
    const DayRef = 1;
    const MonthRef = 6; // Le mois 7

    const DateRef       = new Date(y, MonthRef, DayRef);
    const Aujourdhuit   = new Date(y, m, d);

    if (Aujourdhuit > DateRef) {
        y = y + 1;
    }
    this.passenger.expirationDate = this.formatDate(new Date(y, MonthRef, DayRef));

    
    if (this.typeAddSelected == 'passenger') {

      // Iterate through ListPassager.ListValide
      for (let i = 0; i < this.ListPassager.ListValide.length; i++) {
        const passengerData = this.ListPassager.ListValide[i];
        
        const key = `${passengerData.nom}_${passengerData.tel}`; // Combine name and phone number as key

        // If passenger with same name and phone number exists in map
        if (passengerMap[key]) {
            // Aggregate matricule, prenoms, and count
            passengerMap[key].matricule += `/${passengerData.matricule}`;
            passengerMap[key].prenoms += `/${passengerData.prenoms}`;
            passengerMap[key].nombre++;
        } else {
            // Create new passenger entry in map
            passengerMap[key] = {
                matricule: passengerData.matricule,
                nom: passengerData.nom,
                prenoms: passengerData.prenoms,
                nombre: 1,
                tel: passengerData.tel,
                adresse: passengerData.adresse,
                isReserved: 0,
                abonnement: passengerData.abonnement
            };
        }
      }

    } else if (this.typeAddSelected == 'code') {

      for (let i = 0; i < this.codesToGenerate; i++) {
        const key = `${i}`;
        // Create new passenger entry in map
          passengerMap[key] = {
            matricule: '-',
            nom: '-',
            prenoms: '-',
            nombre: 1,
            tel: '0600000000',
            adresse: '-',
            isReserved: 1,
            abonnement: 'AR'
        };

      }
    }


  // Iterate through passengerMap and create passengers
  for (const key in passengerMap) {
    if (passengerMap.hasOwnProperty(key)) {
        
        const passengerData = passengerMap[key];
        this.passenger.registrationNumbers = passengerData.matricule;
        this.passenger.lastname = passengerData.nom;
        this.passenger.firstnames  = passengerData.prenoms;
        this.passenger.count = passengerData.nombre;
        this.passenger.phone = passengerData.tel;
        this.passenger.address = passengerData.adresse;
        this.passenger.isReserved = passengerData.isReserved;
        switch (passengerData.abonnement) {
          case ('AR' || 'ar'):
            this.passenger.subscription = 'Aller/Retour' ;
            break;
          case ('A' || 'a'):
            this.passenger.subscription = 'Aller' ;
            break;
          case ('R' || 'r'):
            this.passenger.subscription = 'Retour';
            break;
          default:
            this.passenger.subscription = 'Aller/Retour' ;
            break;
        }

        //console.log('this.passenger', this.passenger);

        this.http.post(
          '/api/passenger/0',
          { passenger: this.passenger }
        ).subscribe(
          (passenger: Passenger) => {
            this.passenger = passenger;
            
          },
          (error) => {
            this.pnotify.error({
              title: 'Erreur',
              text: 'Une erreur est survenue !',
              stack: {
                firstpos1: 70, firstpos2: 10,
                modal: true,
                overlay_close: true
              },
              hide: false,
              modules: {
                Confirm: {
                  confirm: true,
                  buttons: [
                    {
                      text: 'OK',
                      addClass: 'btn btn-chico',
                      click: notice => {
                        notice.close();
                      }
                    }
                  ]
                }
              }
            });
          }
        );
      }
        //window.alert("Passager: "+ this.passenger.schoolId +" et "+ this.passenger.busId +" et "+ this.passenger.lastname +" et "+ this.passenger.firstnames +" et "+this.passenger.subscription);
    }
      alert("Opération terminée avec succès");
      this.router.navigate(['/' + this.routeBase + '/list/0/5']);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/passenger/passenger-addlist/passenger-addlist.component.ts